const { default: styled } = require("styled-components");

export const Container = styled.div`
    margin-left:20vw;
    width:80vw;
    height:100%;
    padding:30px;
    padding-top:12vh;
    
    @media only screen and (max-width: 600px) {
        padding-top: 4vh;
        margin-left: 0;
        width: 100%;
        padding-right: 0px;
        padding: 30px;
    }

    .container-input-box{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        .input-box{
            width: 48%;
            margin-left: 0;
        }
        .input-center{
            width: 45%;
            margin-right: 2%;
        }

        .input-box{
            background-color: #eee;
            border-radius: 5px;
            height: 60px;
            width: 100%;
            margin-top: 20px;
            padding-left: 10px;
            padding-right: 15px;
            padding-top: 3px;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: space-evenly;

            small{
                font-weight: 500;
                                        
            }

            input, select{
                background-color: transparent;
                border: transparent;
                border-bottom: 2px solid #ccc;
                width: 100%;
            }
        }

    }

    .container-next{
        height: 50px;
        width: 100%;
        margin-top: 20px;
        display: flex;
        flex-direction: row;
        align-items: space-evenly;
        justify-content: center;

        
        button{
            border: transparent;
            background: linear-gradient(90deg, #EA5C1E 0%, #C13818 100%);
            width: 60%;
            color: white;
            height: 100%;
            border-radius: 4px;
        }

        button:hover{
            color: #EA5C1E;
            background: white;
            text-decoration: none;
            border: 2px solid #EA5C1E;
            filter: none;
            background-color: white;
            background-image: none;
        }

        .btBack{
            margin-right: 4%;
            border: 2px solid #EA5C1E;
            background-color: white;
            background: white;
            color: #EA5C1E;
        }

        .btBack:hover{
            background: linear-gradient(90deg, #EA5C1E 0%, #C13818 100%);
            color: white;
            border: none;
        }
    }
    
  .bread-crumb{
    display:flex;
    align-items:center; 
    margin-bottom:40px;
    
    @media only screen and (max-width: 600px) {
        flex-direction: column;
        margin-top: 2vh;
    }

    .category{
        color: #0A677C;
        margin-right:3px;
        font-weight: bold;
        font-size: 18px;
        line-height: 21px;
        letter-spacing: 0.05em;
    }

    .where{
        color: #EB5C1C;
        text-decoration:none;
        font-weight: bold;
        font-size: 18px;
        line-height: 21px;
        letter-spacing: 0.05em;
    }
  }

    .filter{
        border: 1px solid #C4C4C4;
        border-radius: 4px;
        padding:20px;
        display:flex;
        flex-wrap:wrap;
        .input-group{
            width: 230px;
            height: 59px;
            background: #DADADA;
            border-radius: 4px;
            padding:5px;
            margin-right:10px;
            margin-bottom:10px;
            
            @media only screen and (max-width: 600px) {
                width: 100%;
                margin-right: 0px;
            }
            
            label{
                width:100%;
            }
            input,select{
                width:100%;
                height:60%;
                background:transparent;
                border:none;
                outline:none;
                margin-top: 3px;
                padding-left: 10px;
            }
           
        }
        .button-group{
            margin-left:auto;
            margin-right:85px; 

            @media only screen and (max-width: 600px) {
                width: 100%;
                margin-right: 0;
            }   

            button{
                height: 50px;
            }

            .outline{
                background:transparent;
                outline:none;
                border: 1px solid #EA5C1E;
                padding:10px;
                border-radius: 4px;
                font-weight: normal;
                font-size: 18px;
                line-height: 21px;
                /* identical to box height */
                text-align: center;
                letter-spacing: 0.05em;
                /* #EA5C1E */
                color: #EA5C1E;
                
                @media only screen and (max-width: 600px) {
                    width: 100%;
                }
            }
            .full{
                outline:none;
                background: linear-gradient(90deg, #EA5C1E 0%, #C13818 100%);
                border-radius: 4px;
                border:none;
                padding:10px;
                color:#ffffff;
                margin-left:10px;

                @media only screen and (max-width: 600px) {
                    width: 100%;
                    margin-top: 10px;
                    margin-bottom: 10px;
                    margin-left: 0;
                }
            }
        }
    }
    .row-ordenate{
        display:flex;
        width:100%;
        justify-content:space-between;
        align-items:center;
        margin-top:20px;
        margin-bottom:20px;
        .input-group{
            width: 230px;
            height: 59px;
            background: #DADADA;
            border-radius: 4px;
            padding:5px;
            margin-right:10px;
            margin-bottom:10px;
            
            label{
                width:100%;
            }
            input,select{
                width:100%;
                height:100%;
                background:transparent;
                border:none;
                outline:none;
            }
           
        }
    }
    .header{
        display:flex;
        background: #0A677C;
        border: 1px solid #0A677C;
        border-radius: 4px;
        color:#ffffff;
        height: 50px;

        div{
            height: 100%;
            h2{
                padding-left: 12px;
                display: flex;
                align-items: center;
                height: 100%
            }
        }

        div + div{
            border-left:1px solid #ffffff;
        }

        .cod{
            width: 7%;
            @media only screen and (max-width: 600px) {
                width: 18%;
                font-size: 11px;
            }
        }

        .active{
            width: 40%;
            
            @media only screen and (max-width: 600px) {
                width: 300px;
                font-size: 11px;
            }
        }

        .imovel{
            width: 45%;
            @media only screen and (max-width: 600px) {
                width: 180px;
                font-size: 11px;
            }
        }
        
        .engajamento{
            width: 15%; 
            @media only screen and (max-width: 600px) {
                width: 130px;
                font-size: 11px;
            }
        }

        .stats{
            width: 10%;
        }

        .actions{
            width: 10%;
        }
    }

    .body{
        height: 150px;
        width: 100%;
        margin-top: 20px;
        border-radius: 5px;
        border: 1px solid #aaa;
        display: flex;
        flex-direction: row;
        
        div{
            display: flex;
        }
        
        .body-cod{
            border-right: 1px solid #aaa;
            width: 7%;
            height: 100%;
            color: #0A677C;
            text-align: center;
            justify-content: center;
            align-items: center;
            font-weight: 700;
            font-size: 17px;
            
            @media only screen and (max-width: 600px) {
                width: 18%;
            }

            .input-group{
                width: 230px;
                height: 59px;
                background: #DADADA;
                border-radius: 4px;
                padding:5px; 
                flex-direction: column;
                margin-bottom:25px;
                width: 100%;
                
                label{
                    width:100%;
                    text-align: start;
                }
                input,select{
                    width:100%;
                    height:60%;
                    background:transparent;
                    border:none;
                    outline:none;
                    margin-top: 3px;
                    padding-left: 10px;
                    border-bottom: 1px solid #aaa;
                }
               
            }
        }

        .body-active{
            border-right: 1px solid #aaa;
            width: 40%;
            height: 100%;
            flex-direction: column;  
            
            @media only screen and (max-width: 600px) {
                width: 300px;
            }
            
            div{ 
                // overflow-x: auto;
                padding-left: 22px;
                height: 100%;
                display: flex;  
                flex-direction: column;
                width: 100%;
                font-size: 16px;
                padding-top: 25px; 
            }
            button{
                border: transparent;
                background: linear-gradient(90deg, #EA5C1E 0%, #C13818 100%);
                width: 200px;
                color: white;
                height: 50px;
                font-size: 19px;
                border-radius: 4px;
                bottom: 0;
                margin-left: auto;
            }
            .square{
                width: 48%;
                height: 120px;
                background: #DADADA; 
                border-radius: 4px;
                padding-left: 0px;
                border: 1px solid #BBB;
                padding-top: 10px;
                display: flex;
                flex-direction: column;


                strong {
                    margin-left: 22px;
                    font-weight: 400;
                    margin-top
                }

                h3{
                    width: 100%;
                    height: inherit;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 40px;
                    color: #8B9495;
                    font-family: Ubuntu;
                }
            }

            .square:nth-child(2), .square:nth-child(4) {
                margin-left: 4%
            }
            // .square:nth-child(3), .square:nth-child(4) {
            //     margin-top: 20px;
            // }
 
            .select-group{
                height: auto;
                padding-top: 0;
                padding-left: 0;
                margin-left: auto;
                display:flex;
                flex-direction: row-reverse;
                align-items: center;

                input{
                    cursor: pointer;
                }

                span{
                    margin-right: 10px;
                }
            }
        }
        .body-imovel{
            border-right: 1px solid #aaa;
            width: 45%;
            height: 100%;
            flex-direction: row;
            align-items: center;
            
            @media only screen and (max-width: 600px) {
                width: 180px;
            }

            .opt-left{
                width: 50%;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                padding-left: 20px;
                font-size: 19px;

                a{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    text-align: center;
                    overflow-x: auto;
                    height: 50%;
                    width: 100%;

                    img{
                        padding-right: 8px;
                    }
                }

                a+a{
                    border-top: 1px solid #aaa;
                }
            }
            .opt-right{
                width: 50%;
                height: 100%;
                border-left: 1px solid #aaa;
                display: flex;
                flex-direction: column;


                a{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    text-align: center;
                    overflow-x: auto;
                    height: 50%;
                    width: 100%;
                }

                a+a{
                    border-top: 1px solid #aaa;
                }
            }
        }
        .body-engajamento{
            border-right: 1px solid #aaa;
            width: 15%; 
            height: 100%;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            
            @media only screen and (max-width: 600px) {
                width: 130px;
            }
            
            div{ 
                overflow-x: auto;
                padding-left: 5px;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                width: 100%;
                font-size: 16px;


                a{
                    overflow-x: auto;
                }
            }

            div + div {
                border-top: 1px solid #aaa;
            }
        }
        .body-stats{
            width: 10%;
            height: 100%;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            border-right: 1px solid #aaa;
            
            div{
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                width: 100%;
                color: #1E1D1D;
                font-weight: 300;
                font-size: 20px;


                a{
                    cursor: pointer;
                }
            }

        }
        .body-actions{
            width: 15%; 
            height: 100%;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            @media only screen and (max-width: 600px) {
                width: 130px;
            }
            
            div{
                height: 100%;
                display: flex;
                justify-content: flex-start;
                padding-left: 18px;
                align-items: center;
                width: 100%;
                color: #00AEC8;
                font-size: 20px;

                a{
                    cursor: pointer;
                }
            }

            div + div {
                border-top: 1px solid #aaa;
            }
        }
    }

    .paginate{
        width: 100%;
        height: 30px;
        margin-top: 22px;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;

        .pagination{
            display: flex;
            height: 100%;
            list-style-type: none;
            
            li{
                list-style-type: none;

                a{
                    width: 100%;
                    height: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
            }
            
        }

        div, li{
            height: 100%;
            width: 40px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-bottom: 1px solid #aaa;
            border-top: 1px solid #aaa;
            border-left: 1px solid #aaa;
        }

        .previous {
            width: 70px;
            font-size: 16px;
            border-top-left-radius: 5px;
            border-bottom-left-radius: 5px;
        }

        .next{
            width: 70px;
            border-right: 1px solid #aaa;
            border-top-right-radius: 5px;
            font-size: 16px;
            border-bottom-right-radius: 5px;
        }

        li:hover {
            color: white;
            background: #0A677C;
            cursor: pointer;
        }

        .active {
            background: #0A677C;
            color: white;
        }
    }
`
export const Carousel = styled.div`
    width:100%;
    height:auto;
    overflow-x:auto;
    display:flex;

`
export const PlusBtn = styled.button`  
    margin-left:20px;
    background-color:transparent;
    border:none;
`
export const BtnWrapper = styled.div`
    width: 100%;
    height: 128px;
    display:flex;
    justify-content:center;
    align-items:center;
`
export const DocItem = styled.label`
    min-width: 178px;
    min-height: 128px;
    border-radius: 4px;
    background:url(${props => props.image ? props.image : require('../../assets/adminOfferProperty/docplaceholder.svg')});
    background-repeat:no-repeat;
    background-size:cover;
    background-position:center;
    position:relative;
    cursor:pointer;

    input{
        display:none;
    }

    .close{
        display : ${props => props.children[1].props.show ? 'flex' : 'none '};
        position:absolute;
        width: 16px;
        height: 16px;
        background: #FFFFFF;
        right : 10px;
        top : 10px;
        border:none;
        font-size:16px;
        border-radius:8px;
        align-items:center;
        justify-content:center;
    }
`
export const Item = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
`

export const ItemLink = styled.a`
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
`